import { useId } from "react";

export function WishlistIcon({ active = false }) {
  const ringGradientId = useId();
  const heartGradientId = useId();

  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 44 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={heartGradientId} x1="15" y1="13" x2="29" y2="30">
          <stop offset="0" stopColor="#3AA8FF" />
          <stop offset="0.5" stopColor="#6F7CFF" />
          <stop offset="1" stopColor="#A05CFF" />
        </linearGradient>
      </defs>


      {/* Better heart */}
      <path
          d="
    M22 30.4
    C21.55 30.4 21.18 30.22 20.85 29.92
    C18.45 27.72 16.48 25.78 14.95 24.1
    C13.42 22.42 12.65 20.62 12.65 18.7

    C12.65 17.1 13.18 15.77 14.25 14.7
    C15.32 13.63 16.65 13.1 18.25 13.1

    C19.15 13.1 19.95 13.3 20.65 13.7
    C21.35 14.1 21.8 14.62 22 15.25

    C22.2 14.62 22.65 14.1 23.35 13.7
    C24.05 13.3 24.85 13.1 25.75 13.1

    C27.35 13.1 28.68 13.63 29.75 14.7
    C30.82 15.77 31.35 17.1 31.35 18.7

    C31.35 20.62 30.58 22.42 29.05 24.1
    C27.52 25.78 25.55 27.72 23.15 29.92
    C22.82 30.22 22.45 30.4 22 30.4
    Z
  "
      fill={active ? `url(#${heartGradientId})` : ''}
        stroke="white"
        strokeWidth="2.05"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}